<template>
   <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
                <h3 class="card-title mb-0">Daftar Paket Internet</h3>

                <div class="card-tools d-flex align-items-center flex-wrap mt-2 mt-md-0">
                  <div class="mr-2 d-flex align-items-center">
                    <label class="mb-0 mr-2 font-weight-normal text-muted" style="white-space: nowrap; font-size: 14px;">Tampilkan:</label>
                    <select v-model="per_page" @change="loadData" class="form-control form-control-sm">
                      <option value="15">15</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="all">Semua</option>
                    </select>
                  </div>

                  <select v-model="filter_active" @change="loadData" class="form-control form-control-sm mr-2" style="width: 140px;">
                    <option value="">Semua Status</option>
                    <option value="1">Aktif</option>
                    <option value="0">Non-Aktif</option>
                  </select>

                  <div class="input-group input-group-sm mr-2" style="width: 200px;">
                    <input type="text" v-model="search" @keyup.enter="loadData" class="form-control" placeholder="Cari nama paket...">
                    <div class="input-group-append">
                      <button type="button" class="btn btn-default" @click="loadData">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal" style="white-space: nowrap;">
                      <i class="fa fa-plus-square"></i> Tambah
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th style="width: 70px; text-align:'center'">NO</th>
                      <th>Nama</th>
                      <th>Kecepatan (byte)</th>
                      <th>Harga (Rp)</th>
                      <th>Paket Tertulis di Invoice</th>
                      <th>Paket Untuk</th>
                      <th>Status</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in dataset.data" :key="row.id">

                      <td style="width: 20px">{{ (dataset.current_page - 1) * dataset.per_page + index + 1 }}</td>
                      <td>{{row.value}}</td>
                      <td>{{row.kecepatan}}</td>
                      <td>{{formatRupiah(row.harga)}}</td>
                      <td>{{row.nama_invoice}}</td>
                      <td>{{row.tipe_paket_nama}}</td>
                      <td>
                        <span class="badge badge-success" v-if="row.sts_paket == 1">Aktif</span>
                        <span class="badge badge-danger" v-else>Non-Aktif</span>
                      </td>
                      <!-- <td><img v-bind:src="'/' + product.photo" width="100" alt="product"></td> -->
                      <td>
                        <button class="btn btn-sm btn-warning mr-1" @click="toggleActive(row)" :title="row.sts_paket == 1 ? 'Non-aktifkan' : 'Aktifkan'">
                            <i class="fa" :class="row.sts_paket == 1 ? 'fa-ban' : 'fa-check'"></i>
                        </button>
                        <button class="btn btn-sm btn-info mr-1" @click="editModal(row)" title="Edit">
                            <i class="fa fa-edit text-white"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click="deleteData(row.id)" title="Hapus">
                            <i class="fa fa-trash text-white"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="dataset" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Paket</h5>
                    <h5 class="modal-title" v-show="editmode">Edit Paket</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateData() : createData()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama</label>
                            <input v-model="form.value" type="text" name="value"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('value') }" required>
                            <has-error :form="form" field="value"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Masa Aktif (Hari)</label>
                            <input v-model="form.masa_aktif" type="text" name="masa_aktif"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('masa_aktif') }" required>
                            <has-error :form="form" field="masa_aktif"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Kecepatan (byte)</label>
                            <input v-model="form.kecepatan" type="text" name="kecepatan"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('kecepatan') }" required>
                            <has-error :form="form" field="kecepatan"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Harga (RP)</label>
                            <input v-model="form.harga" type="text" name="harga"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('harga') }" required>
                            <has-error :form="form" field="harga"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Tertulis di Invoice</label>
                            <input v-model="form.nama_invoice" type="text" name="nama_invoice"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama_invoice') }" required>
                            <has-error :form="form" field="nama_invoice"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Tipe Paket Untuk Pengguna</label>
                            <select v-model="form.tipe_paket" type="text" name="tipe_paket"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('tipe_paket') }" required>
                                <!-- inline object literal -->
                              <option 
                                selected
                                disabled
                                value="">Pilih...
                              </option>
                              <option v-bind:value="1">PPPOE</option>
                              <option v-bind:value="2">CORPORATE</option>
                              <!--option v-bind:value="3">EVENT</option-->
                              <option v-bind:value="99">SEMUA</option>
                            </select>
                            <has-error :form="form" field="tipe_paket"></has-error>  
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Edit!</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Tambah!</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import { formatRupiah } from '../../helpers/format';
    export default {
        data () {
            return {
                per_page: 15,
                search: '',
                filter_active: '',
                editmode: false,
                dataset : {},
                form: new Form({
                    id : '',
                    value : '',
                    harga: '',
                    kecepatan: '',
                    masa_aktif: '',
                    nama_invoice: '',
                    tipe_paket: '',
                })
            }
        },
        methods: {
          formatRupiah,
          getResults(page = 1) {

              this.$Progress.start();
              
              axios.get('api/paket?page=' + page + '&per_page=' + this.per_page + '&sts_paket=' + this.filter_active + '&search=' + this.search).then(({ data }) => (this.dataset = data.data));

              this.$Progress.finish();
          },
          loadData(){

            // if(this.$gate.isAdmin()){
              axios.get('api/paket?per_page=' + this.per_page + '&sts_paket=' + this.filter_active + '&search=' + this.search).then(({ data }) => (this.dataset = data.data));
            // }
          },
          editModal(rowEdit){
              this.editmode = true;
              this.form.reset();
              $('#addNew').modal('show');
              this.form.fill(rowEdit);
          },
          newModal(){
              this.editmode = false;
              this.form.reset();
              $('#addNew').modal('show');
          },
          createData(){
              this.$Progress.start();

              this.form.post('api/paket')
              .then((data)=>{
                if(data.data.success){
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                  this.$Progress.finish();
                  this.loadData();

                } else {
                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });

                  this.$Progress.fail();
                }
              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          },
          updateData(){
              this.$Progress.start();
              this.form.put('api/paket/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');

                  this.loadData();
              })
              .catch(() => {
                  this.$Progress.fail();
              });

          },
          deleteData(id){
              Swal.fire({
                  title: 'Yakin untuk menghapus?',
                  text: "Paket yang memiliki Pengguna Terhubung tidak dapat dihapus!. Yakin untuk Menghapus Paket?",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya, Hapus!'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                              this.form.delete('api/paket/'+id).then(()=>{
                                      Swal.fire(
                                      'Terhapus!',
                                      'Data Paket Berhasil Dihapus.',
                                      'success'
                                      );
                                  // Fire.$emit('AfterCreate');
                                  this.loadData();
                              }).catch((data)=> {
                                  Swal.fire("Hapus Gagal!", data.message, "warning");
                              });
                        }
                  })
          },
          toggleActive(row) {
              let actionText = row.sts_paket == 1 ? 'Menon-aktifkan' : 'Mengaktifkan';
              Swal.fire({
                  title: 'Konfirmasi',
                  text: `Yakin ingin ${actionText} paket ${row.value}?`,
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Ya, lanjutkan!'
              }).then((result) => {
                  if (result.value) {
                      this.$Progress.start();
                      axios.put('api/paket/toggle_active/' + row.id)
                      .then((response) => {
                          Toast.fire({
                            icon: 'success',
                            title: response.data.message
                          });
                          this.$Progress.finish();
                          this.loadData();
                      })
                      .catch(() => {
                          this.$Progress.fail();
                          Toast.fire({
                              icon: 'error',
                              title: 'Terjadi kesalahan!'
                          });
                      });
                  }
              });
          },

        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadData();

            this.$Progress.finish();
        }
    }
</script>